import {
  AuthLoginByRoutePage,
  AuthLogoutPage,
  ByFacebookTokenContainer,
  ByGoogleTokenContainer,
  ByAppleTokenContainer,
  RegisterByAppleTokenContainer,
  RegisterByGoogleTokenContainer,
  RegisterByFacebookTokenContainer,
  AuthActivatePage,
  RETURN_URL_ACTIVATE,
} from '@front-activerse/common-components';
import {
  AuthLoginByEmailAndPasswordPage,
  AuthRemindPasswordPage,
  AuthResetPasswordPage,
  ConfirmPage as AuthConfirmPage,
} from '@front-activerse/modules';
import { Layout } from '@front-activerse/modules';
import { ErrorNoAccount } from '@front-activerse/modules';
import { externalWebView } from '@front-activerse/common-components';

const dummy_t = (translationKey) => translationKey;

const isExternamWebView = externalWebView();

const routes = [
  {
    path: '/auth/login',
    private: false,
    title: dummy_t('app.default.navbarTitle'),
    element: (
      <AuthLoginByEmailAndPasswordPage
        displayGoogleButton={isExternamWebView ? false : true}
        displayFacebookButton={false}
        displayRegisterButton={false}
      />
    ),
  },
  {
    path: '/auth/logout',
    private: true,
    title: dummy_t('app.default.navbarTitle'),
    mobileAppTabIdentifier: 'Authorization',
    element: <AuthLogoutPage />,
  },
  {
    path: '/auth/login/by-token/:token',
    private: false,
    title: dummy_t('app.default.navbarTitle'),
    element: (
      <Layout simpleLayout>
        <AuthLoginByRoutePage />
      </Layout>
    ),
  },
  {
    path: '/auth/remind-password',
    private: false,
    title: dummy_t('app.default.navbarTitle'),
    element: (
      <Layout simpleLayout>
        <AuthRemindPasswordPage />
      </Layout>
    ),
  },
  {
    path: '/auth/reset-password/:token',
    element: (
      <Layout simpleLayout>
        <AuthResetPasswordPage />
      </Layout>
    ),
    private: false,
    title: dummy_t('app.default.navbarTitle'),
  },
  {
    path: '/auth/login/via-facebook',
    element: (
      <Layout simpleLayout>
        <ByFacebookTokenContainer />
      </Layout>
    ),
    exact: true,
    private: false,
    title: dummy_t('app.default.navbarTitlet'),
  },
  {
    path: '/auth/login/via-google',
    element: (
      <Layout simpleLayout>
        <ByGoogleTokenContainer />
      </Layout>
    ),
    exact: true,
    private: false,
    title: dummy_t('app.default.navbarTitle'),
  },
  {
    path: '/auth/login/via-apple',
    element: (
      <Layout simpleLayout>
        <ByAppleTokenContainer />
      </Layout>
    ),
    exact: true,
    private: false,
    title: dummy_t('app.default.navbarTitle'),
  },
  {
    path: '/auth/register/via-facebook',
    element: (
      <Layout simpleLayout>
        <RegisterByFacebookTokenContainer />
      </Layout>
    ),
    exact: true,
    private: false,
    title: dummy_t('app.default.navbarTitle'),
  },
  {
    path: '/auth/register/via-google',
    element: (
      <Layout simpleLayout>
        <RegisterByGoogleTokenContainer />
      </Layout>
    ),
    exact: true,
    private: false,
    title: dummy_t('app.default.navbarTitle'),
  },
  {
    path: '/auth/register/via-apple',
    element: (
      <Layout simpleLayout>
        <RegisterByAppleTokenContainer />
      </Layout>
    ),
    exact: true,
    private: false,
    title: dummy_t('app.default.navbarTitle'),
  },
  {
    path: '/auth/activate/via-facebook',
    element: (
      <Layout simpleLayout>
        <RegisterByFacebookTokenContainer />
      </Layout>
    ),
    exact: true,
    private: false,
    title: dummy_t('app.default.navbarTitle'),
  },
  {
    path: '/auth/activate/via-google',
    element: (
      <Layout simpleLayout>
        <RegisterByGoogleTokenContainer returnUrl={RETURN_URL_ACTIVATE} />
      </Layout>
    ),
    exact: true,
    private: false,
    title: dummy_t('app.default.navbarTitle'),
  },
  {
    path: '/auth/activate/via-apple',
    element: (
      <Layout simpleLayout>
        <RegisterByAppleTokenContainer />
      </Layout>
    ),
    exact: true,
    private: false,
    title: dummy_t('app.default.navbarTitle'),
  },
  {
    path: '/auth/no-account',
    element: <ErrorNoAccount />,
    exact: true,
    private: false,
    title: dummy_t('app.default.navbarTitle'),
  },
  {
    path: '/auth/activate/:token',
    element: (
      <Layout simpleHeader>
        <AuthActivatePage />
      </Layout>
    ),
    private: false,
    exact: true,
    title: dummy_t('app.default.navbarTitle'),
  },
  {
    path: '/auth/confirm',
    element: <AuthConfirmPage />,
    private: false,
    exact: false,
    title: dummy_t('app.default.navbarTitle'),
  },
];

export default routes;
